import * as React from "react";
import {useIntl} from "react-intl";
import {Dropdown} from "primereact/dropdown";
import {SupportedInvoiceIcons} from "../../../lib/types/types";
import {supportedColors, supportedIcons} from "./invoice-icons";
import {MultiSelect} from "primereact/multiselect";
import {Checkbox} from "primereact/checkbox";

interface Props {
    options: any;
}

export interface InvoiceIconOption {
    icon: SupportedInvoiceIcons;
    color: string;
}

interface InvoiceIconGroup {
    icon: string;
    items: InvoiceIconOption[];
}

export const InvoiceIconsFilter: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();

    const groupedInvoiceIcons: InvoiceIconGroup[] = supportedIcons.map(icon => {
        return {
            icon,
            items: supportedColors.map(color => {
                {
                    return {
                        icon,
                        color
                    }
                }
            })
        }
    })

    const groupedItemTemplate = (option: InvoiceIconGroup) => {
        const isChecked = props.options.value && props.options.value.length && props.options.value.filter((el: InvoiceIconOption) => el.icon === option.icon).length === supportedColors.length;
        const itemsInGroup = groupedInvoiceIcons.find(group => group.icon === option.icon)?.items || [];
        const checkGroup = () => {
            props.options.filterApplyCallback(props.options.value ? [...props.options.value.filter((el: InvoiceIconOption) => el.icon !== option.icon), ...itemsInGroup] : [...itemsInGroup]);
        }
        const uncheckGroup = () => {
            props.options.filterApplyCallback(props.options.value ? props.options.value.filter((el: InvoiceIconOption) => el.icon !== option.icon) : []);
        }
        return <div className={'flex gap-2'}><span className={`pi ${option.icon} text-xl`}/>
            <Checkbox checked={isChecked} onClick={() => isChecked ? uncheckGroup() : checkGroup()}/>
        </div>
    };

    const itemTemplate = (option: InvoiceIconOption) => {
        return <span className={`pi ${option.icon} ${option.color}`}/>
    };

    return <>
        <MultiSelect showClear value={props.options.value}
                     options={groupedInvoiceIcons} className={'invoice-icon'}
                     optionGroupChildren="items"
                     maxSelectedLabels={0}
                     optionGroupLabel={'icon'}
                     optionLabel={'icon'}
                     itemTemplate={itemTemplate}
                     optionGroupTemplate={groupedItemTemplate}
                     onChange={(e) => {
                         props.options.filterApplyCallback(e.value)
                     }}
                     style={{textAlign: "left"}}/>
    </>
};

